import * as model from './model.js';
import { MODAL_CLOSE_SEC } from './config.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import bookmarksView from './views/bookmarksView.js';
import paginationView from './views/paginationView.js';
import addRecipeView from './views/addRecipeView.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

// if(module.hot){
//   module.hot.accept();
// }

const controlRecipes = async function () {
  try{
    const id =  window.location.hash.slice(1);

    if(!id) return;
    recipeView.renderSpinner();

    //1) update results view to mark selected search result
    resultsView.update(model.getSearchResultsPage());

    //2) updating bookmark
    bookmarksView.update(model.state.bookmarks);

    //3) loading recipe
    await model.loadRecipe(id);

    //4) rendering recipe
    recipeView.render(model.state.recipe);
  } catch(err){
    recipeView.renderError();
    console.error(err);
  }
};

const controlSearchResults = async function () {
  try{
    resultsView.renderSpinner();

    //1) get search query
    const query = searchView.getQuery();
    if(!query) return;

    //2) load search results
    await model.loadSearchResults(query);

    //3) render results
    resultsView.render(model.getSearchResultsPage());

    //4) render initial pagination datas
    paginationView.render(model.state.search);
  }catch(err){
    console.log(err);
  }
};

const controlPagination = function(goToPage){
  //1) render NEW results
  resultsView.render(model.getSearchResultsPage(goToPage));

  //2) render NEW pagination buttons
  paginationView.render(model.state.search);
};

const controlServings = function(newServings){
  //Update the recipe servings (in state)
  model.updateServings(newServings);

  //Update the recipe view
  recipeView.update(model.state.recipe);
};

const controlAddBookmark = function(){
  //1) add/remove bookmark
  if(!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);

  //2) update recipe view
  recipeView.update(model.state.recipe);

  //3) render bookmarks
  bookmarksView.render(model.state.bookmarks);
};

const controlBookmarks = function(){
  bookmarksView.render(model.state.bookmarks)
};

const controlAddRecipe = async function(newRecipe){
  try{
    //show loading spinner
    addRecipeView.renderSpinner();

    //upload new recipe data
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);

    //render recipe
    recipeView.render(model.state.recipe);

    //success message
    addRecipeView.renderMessage();

    //render bookmark view
    bookmarksView.render(model.state.bookmarks);

    //change ID in URl
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    //close form windows
    setTimeout(function() {
      addRecipeView.toggleWindow();
    }, MODAL_CLOSE_SEC * 1000);
  } catch(err){
    console.error(err);
    addRecipeView.renderError(err.message);
  }
};

const init = function(){
  bookmarksView.addHandlerRender(controlBookmarks);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark)
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
}
init();